import React, { Component } from 'react';
import Node from '../nodes/Node'
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { resetClient } from '../../actions';

const cookies = new Cookies();

export class Logout extends Component {

  render() {
    return (
      <div>
        <Node id={this.props.server.rootId} number='0' parent='0' root={true} page={0}/>
      </div>
    )
  }

  componentWillMount() {
    cookies.remove('api_access_token', { path: '/' })
    cookies.remove('name', { path: '/' })
  };
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
  resetClient
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout)



// WEBPACK FOOTER //
// ./src/components/SignupLogin/Logout.js